import axios from 'axios';

let prefix = "/unit-stat-preset"

const UnitStatPresetApi = {
	listUnitStatPreset(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	createUnitStatPreset(payload) {
		return axios.post(prefix + "/create", payload)
	},
	archiveUnitStatPreset(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	}
}

export default UnitStatPresetApi
